import React from 'react';
import '../../Default.css';


function Insurance() {
    return (
        <>
            <div className="page-title">
                Ubezpieczenie
            </div>
            <div className='boxes-contener'>
                <div className="copyright-tekst">paczka informacyjna ZHR</div>
                <div className="text-box">
                    <div className="text-box-accent">Na czas wyjazdu jesteśmy ubezpieczeni. Poniżej przedstawiam informacje przesłane nam przez Krajowe Biuro Organizacyjne ŚDM: </div>
                    <ul>
                        <li>Numer polisy - PZU - <b>1080567730</b>, numer alarmowy: +48 22 566 55 44</li>
                        <li>Numer do bezpośredniego kontaktu - specjalnie dedykowany do grupy: +48 573 352 123. Należy dzwonić w sytuacji, która jest objęta ubezpieczeniem. </li>
                        <li>W Lizbonie będą przy Kwaterze Polskiej pomagać w dniach 2-6 sierpnia panowie asystenci dedykowani do grupy KBO ŚDM - Tomasz Śliwiński i Paweł Klatka. Kontakt do nich na podany numer telefonu dostępny od 15 lipca do 15 sierpnia.</li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export default Insurance;
